import common from '../common';
import Scene from './Scene';
import {translate, Text, localeFont} from '../utils';
import DrawingSpine from "../drawing/DrawingSpine";
import paper from "paper";
import DrawingTextureHack from "../drawing/DrawingTextureHack";
import Drawing from "../drawing/Drawing";
import {saveAs} from "file-saver";

export default class ResultsScene extends Scene {
    constructor() {
        super();
    }

    init() {
        super.init();

        this._bg = new PIXI.Sprite(P3.assets.texture('bg_game'));
        // bg.anchor.set(0.5);
        //  bg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this._bg.width = common.STAGE_WIDTH;
        this._bg.height = common.STAGE_HEIGHT;
        this.addChild(this._bg);

        const paper = new PIXI.NineSlicePlane(P3.assets.texture("paper"), 16, 16, 16, 40);
        paper.width = 580;
        paper.height = 600;
        paper.pivot.set(paper.width * 0.5, paper.height * 0.5);
        paper.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(paper);

        const tape = new PIXI.Sprite(P3.assets.texture("tape"));
        tape.anchor.set(0.5);
        tape.position.set(paper.x, paper.y - paper.height * 0.5);
        this.addChild(tape);

        /*
        this._drawingSpine = new DrawingSpine(P3.assets.spineData("gumball_darwin_00"), "gumball_darwin_00");
        this._drawingSpine.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(this._drawingSpine);

        const hacks = common.saveData.getSpineHacks("gumball_darwin_00");

        console.log(hacks);

        for (const key in hacks) {
            if (hacks.hasOwnProperty(key)) {
                const hack = hacks[key];
                this._drawingSpine.addTextureHack(hack);
            }
        }

         */
        /*
        this._drawing = new Drawing();
        this._drawing.init();

        this._spine = this.createDrawingSpine({texName: "gumball_darwin_00_data", spine: {name: "gumball_darwin_00"}});
        this._spine.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - 220);
        this.addChild(this._spine);

        this._spine.state.setAnimation(0, "final_1", true);

         */

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_small_out');
        states.over = P3.assets.texture('btn_primary_small_over');
        states.down = P3.assets.texture('btn_primary_small_down');
        states.icon = P3.assets.texture('icon_sound_on');
        states.iconAlt = P3.assets.texture('icon_sound_off');
        this._muteButton = new P3.MuteButton(states);
        this.addChild(this._muteButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_large_out');
        states.over = P3.assets.texture('btn_primary_large_over');
        states.down = P3.assets.texture('btn_primary_large_down');// P3.assets.texture('btn_primary_large_down');
        states.icon = P3.assets.texture('icon_download');

        this._saveButton = new P3.Button(states);
        this._saveButton.signals.click.add(this.onSaveButton, this);
        this._saveButton.position.set(common.STAGE_WIDTH * 0.5 + 280, common.STAGE_HEIGHT - 130);
        this.addChild(this._saveButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_medium_out');
        states.over = P3.assets.texture('btn_primary_medium_over');
        states.down = P3.assets.texture('btn_primary_medium_down');// P3.assets.texture('btn_primary_large_down');
        states.icon = P3.assets.texture('icon_replay');

        this._replayButton = new P3.Button(states);
        this._replayButton.signals.click.add(this.onReplayButton, this);
        this._replayButton.position.set(common.STAGE_WIDTH * 0.5 + 125, common.STAGE_HEIGHT - 100);
        this.addChild(this._replayButton);

        this._labelPanelA = new PIXI.Sprite(P3.assets.texture("title_bg"));
        this._labelPanelA.anchor.set(0.5);
        this.addChild(this._labelPanelA);

        this._labelPanelB = new PIXI.Sprite(P3.assets.texture("title_bg"));
        this._labelPanelB.anchor.set(0.5);
        this.addChild(this._labelPanelB);

        this._labelA = new PIXI.Text(translate("complete_a"), {
            fontFamily: localeFont(),
            fontSize: 62,
            dropShadow: true,
            dropShadowAngle: 2.5,
            dropShadowColor: "#fe2e8b",
            fill: "#ffffff",
        });
        this._labelA.anchor.set(0.5);
        this._labelPanelA.addChild(this._labelA);

        this._labelB = new PIXI.Text(translate("character"), {
            fontFamily: localeFont(),
            fontSize: 62,
            dropShadow: true,
            dropShadowAngle: 2.5,
            dropShadowColor: "#fe2e8b",
            fill: "#fed917",
        });
        this._labelB.anchor.set(0.5);
        this._labelPanelB.addChild(this._labelB);
    }

    destroy() {
        super.destroy();
    }

    resize() {
        super.resize();

        this._muteButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 100, 100);
        this._labelPanelA.position.set(common.STAGE_WIDTH * 0.5 - 240, common.STAGE_HEIGHT - 130);
        this._labelPanelB.position.set(common.STAGE_WIDTH * 0.5 - 200, common.STAGE_HEIGHT - 60);
    }

    update(dt = window.deltaTime) {
        super.update();
        this._spine.update(dt);
    }

    createDrawingSpine(data) {
        this._data = P3.assets.json(data.texName);
        //   const holder = new PIXI.Container();
        // data.container.addChild(holder);

        let spine = new DrawingSpine(P3.assets.spineData(this._data.spine.name), this._data.spine.name, data.texName);
        spine.scale.set(0.5);          //this._data.spine.scale
        spine.autoUpdate = false;
        spine.stateData.defaultMix = 0.2;
        //   holder.addChild(spine);

        //    holder.position.set(data.posx, data.posy + holder.height * 0.5);

        let hacks = common.saveData.getSpineHacks(this._data.spine.name);

        if ($.isEmptyObject(hacks) || hacks === undefined) {
            hacks = false;
        }

        //   spine.visible = this._hasDrawnSpines = hacks;

        for (let i in hacks) {
            if (hacks.hasOwnProperty(i)) {
                const t = hacks[i];
                const path = new paper.CompoundPath();
                path.importJSON(t.path);

                const slot = spine.skeleton.findSlot(i);
                const center = this.toLocal(slot.currentSprite.position, slot.currentSprite.parent);
                path.position.set(center.x + t.offset.x, center.y + t.offset.y);
                spine.addTextureHack(DrawingTextureHack.create(path, slot, center));
            }
        }
        // const anim = localStorage.getItem('jerry_ear_draw') && (parseInt(localStorage.getItem('jerry_ear_draw')) > 0) ? data.finish_animation : data.animation;
        //  spine.state.addAnimation(0, anim, true, 0);
        //  spine.update(P3.Ticker.dt);


        /*
        spine.interactive = true;
        spine.buttonMode = true;
        spine.on('pointerdown', () => {
            this.onHolderClick(data.texName);
        }, this);

        this._spines.push(spine);


         */

        return spine;
    }

    onSaveButton() {
        const data = common.renderer.plugins.extract.canvas(this._spine);

        //const file = {total_words: data.length, packed_dictionary: packed};
        //   const blob = data.toBlob();
        //    saveAs(blob, "screen.png");

        data.toBlob(function (blob) {
            saveAs(blob, "screenshot.png");
        }, "image/png");
    }

    onReplayButton() {
        this.signals.next.dispatch();
    }
}
